export const ASSOCIATIONS_LOADING_MESSAGE = 'Loading associations, chromosomes and statistics data...';
